import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Department, SkillResponse, CategoryResponse, NewCategory, UserSkill, ByEmployee, NewSkillUpdate, Expertise, FilterResponse, NewSkill, DepartmentResult, CategoryResult, NewSkillUpdateByExpertise, Status } from '../api-interfaces';
import { Observable } from 'rxjs';
import { map, refCount, publishReplay } from 'rxjs/operators';
@Injectable()
export class SkillService {
  public editDataCategory;
  public editDataSkill;
  public userDetail;
  constructor(private http: HttpClient) { }

  private getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'uid': localStorage.getItem('uid')
    });
  }
  // category component service methods
  getDepartment(): Observable<Department[]> {
    const requestUrl = `${environment.skill_matrix_api}department`;
    const headers = this.getHeaders();
    return this.http.get<Department[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  getCategory(): Observable<CategoryResponse[]> {
    const requestUrl = `${environment.skill_matrix_api}category/categories`;
    const headers = this.getHeaders();
    return this.http.get<CategoryResponse[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  getCategoryDepartment(): Observable<DepartmentResult[]> {
    const requestUrl = `${environment.skill_matrix_api}category/departments`;
    const headers = this.getHeaders();
    return this.http.get<DepartmentResult[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  newCategory(newCategory): Observable<NewCategory> {
    const requestUrl = `${environment.skill_matrix_api}category`;
    const headers = this.getHeaders();
    return this.http.post<NewCategory>(requestUrl, newCategory, { headers: headers });
  }
  updateNewCategory(updateCategory): Observable<NewCategory> {
    const requestUrl = `${environment.skill_matrix_api}category`;
    const headers = this.getHeaders();
    return this.http.put<NewCategory>(requestUrl, updateCategory, { headers: headers });
  }
  deleteCategory(id): Observable<CategoryResponse> {
    const requestUrl = `${environment.skill_matrix_api}category`;
    const options = {
      headers: this.getHeaders(),
      body: { 'category_id': id }
    };
    return this.http.delete<CategoryResponse>(requestUrl, options);
  }

  // skill Update component service method
  getSkillList(id): Observable<UserSkill[]> {
    const requestUrl = `${environment.skill_matrix_api}employee/` + id;
    const headers = this.getHeaders();
    return this.http.get<UserSkill[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  // Deprecated create skill service method
  newSkillCreate(skillData, id): Observable<NewSkillUpdate> {
    const requestUrl = `${environment.skill_matrix_api}employee`;
    const headers = this.getHeaders();
    const body = { 'employee_id': id, 'employee_skills': { 'data': skillData } }
    return this.http.post<NewSkillUpdate>(requestUrl, body, { headers: headers });
  }
  newSkillCreateByExpertise(skillId, expertiseId, employeeId): Observable<NewSkillUpdateByExpertise> {
    const requestUrl = `${environment.skill_matrix_api}employee`;
    const headers = this.getHeaders();
    const body = { 'employee_id': employeeId, 'skill_id': skillId, 'expertise_id': expertiseId }
    return this.http.post<NewSkillUpdateByExpertise>(requestUrl, body, { headers: headers })
      .pipe(map(response => response));
  }

  // Expertise
  getExpertise(): Observable<Expertise> {
    const headers = this.getHeaders();
    const requestUrl = `${environment.skill_matrix_api}expertise`
    return this.http.get<Expertise>(requestUrl, { headers: headers })
      .pipe(publishReplay(1),
      refCount(),map(response => response['data']));
  }

  // skill component service method
  getSkill(): Observable<SkillResponse[]> {
    const requestUrl = `${environment.skill_matrix_api}skill`;
    const headers = this.getHeaders();
    return this.http.get<SkillResponse[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  // Dropdown for skill list
  getCategoryBySkill(filterSkill?): Observable<SkillResponse[]> {
  const requestUrl = `${environment.skill_matrix_api}skill/list/all`;
  const headers = this.getHeaders();
  return this.http.post<SkillResponse[]>(requestUrl, filterSkill, { headers: headers })
    .pipe(map(response => response['data']));
  }
  // Dropdown for category list
  getCategoryByDepartment(filterCategory?): Observable<CategoryResponse[]> {
    const requestUrl = `${environment.skill_matrix_api}category/list/all`;
    const headers = this.getHeaders();
    return this.http.post<CategoryResponse[]>(requestUrl, filterCategory, { headers: headers })
      .pipe(map(response => response['data']));
  }
  newskill(newSkill): Observable<NewSkill> {
    const requestUrl = `${environment.skill_matrix_api}skill`;
    const headers = this.getHeaders();
    return this.http.post<NewSkill>(requestUrl, newSkill, { headers: headers });
  }
  updateNewSkill(updateSkill): Observable<NewSkill> {
    const requestUrl = `${environment.skill_matrix_api}skill`;
    const headers = this.getHeaders();
    return this.http.put<NewSkill>(requestUrl, updateSkill, { headers: headers });
  }
  deleteSkill(id, skillName, catId): Observable<SkillResponse> {
    const requestUrl = `${environment.skill_matrix_api}skill`;
    const options = {
      headers: this.getHeaders(),
      body: { 'skill_id': id, 'skill_name': skillName, 'category_id': catId }
    };
    return this.http.delete<SkillResponse>(requestUrl, options);
  }

  // filter services methods
  getEmployee(): Observable<ByEmployee> {
    const head = new HttpHeaders({
    'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'uid': localStorage.getItem('uid')
    });
    const requestUrl = `${environment.skill_matrix_api}user`;
    const headers = head;
    return this.http.get<ByEmployee>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  getSkillFilter(filterData): Observable<FilterResponse> {
    const requestUrl = `${environment.skill_matrix_api}filter/skills/all`;
    const headers = this.getHeaders();
    return this.http.post<FilterResponse>(requestUrl, filterData, { headers: headers })
  }
  getCategorySkillByDepartments(): Observable<DepartmentResult[]> {
    const requestUrl = `${environment.skill_matrix_api}filter/skills/base/list`;
    const headers = this.getHeaders();
    return this.http.get<DepartmentResult[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  getUserByDepartment(id): Observable<FilterResponse> {
    const requestUrl = `${environment.skill_matrix_api}user/department/` + id;
    const headers = this.getHeaders();
    return this.http.get<FilterResponse[]>(requestUrl, { headers: headers })
      .pipe(map(response => response['data']));
  }
  searchByUser(id): Observable<FilterResponse> {
    const requestUrl = `${environment.skill_matrix_api}filter/employees`;
    const headers = this.getHeaders();
    return this.http.post<FilterResponse>(requestUrl, { 'employee_id': id }, { headers: headers })
  }
  getSkillData(catName, skill, expertise): Observable<FilterResponse> {
    const requestUrl = `${environment.skill_matrix_api}filter/skills`;
    const headers = this.getHeaders();
    return this.http.post<FilterResponse>(requestUrl, { filter: [{ 'category_name': catName, 'skill_name': skill, 'expertise': expertise }] }, { headers: headers })
  }

  skillEnable(skillId) {
    const requestUrl = `${environment.skill_matrix_api}skill/enable`;
    const headers = this.getHeaders();
    return this.http.put<Status>(requestUrl, { 'skill_id': skillId }, {headers: headers});
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/services/skill.service.ts